module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/jupiter/jupiter_vis-7ab60153ca010e57fb7dfe28bf4fb8c9.jpg";